export default "__VITE_ASSET__C7YTCd00__"